import AddUserModalInputText from './component'

export default AddUserModalInputText



// WEBPACK FOOTER //
// ./src/components/AddUserModalInputText/index.js